angular.module('property-price-list')
    .component('propertyPriceListStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span class="label label-default property-price-list-status {{$ctrl.status}}">{{ "property-price-list.status." + $ctrl.status | translate }}</span>
        `
    })
